import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Collections from './components/Collections';
import Culture from './components/Culture';
import Drops from './components/Drops';

function App() {
  const [activeDot, setActiveDot] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll effect for header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-rotate carousel dots
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDot((prev) => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setActiveDot(index);
  };

  const handleNavClick = (e, target) => {
    e.preventDefault();
    const element = document.querySelector(target);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <Header 
        isScrolled={isScrolled} 
        handleNavClick={handleNavClick} 
      />
      
      <Hero 
        activeDot={activeDot} 
        handleDotClick={handleDotClick} 
      />
      
      <Collections />
      
      <Culture />
      
      <Drops />
    </div>
  );
}

export default App;
